export const types = {
  LOAD_NAV: 'LOAD_NAV',
  LOAD_NAV_SUCCESS: 'LOAD_NAV_SUCCESS',
  LOAD_NAV_FAILED: 'LOAD_NAV_FAILED',
  UNAUTHORIZED: 'UNAUTHORIZED'
};



// WEBPACK FOOTER //
// ./src/components/common/Nav/ducks/types.js